// src/pages/BlogPage/BlogPage.jsx
import { useEffect, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Pagination } from 'antd';

import { getAllPosts } from '../../api/postsApi';
import { getTranslation, normalizeLang } from '../../helpers/translation';
import style from './BlogPage.module.css';
import BlogArticleItem from './BlogArticleItem/BlogArticleItem';
import SEOHelmet from '../../components/SEO/SEOHelmet';

export default function BlogPage() {
  const { lang: rawLang } = useParams();
  const lang = normalizeLang(rawLang);
  const t = useMemo(() => getTranslation(lang), [lang]);

  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(12);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const topRef = useRef(null);

  useEffect(() => {
    setPage(1);
  }, [lang]);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getAllPosts({
      page,
      limit,
      sort: '-createdAt',
      language: lang || 'en',
    })
      .then(data => {
        if (cancelled) return;
        const nTotal = Number(data?.total ?? 0);
        const nLimit = Number(data?.limit ?? limit);
        const nPages = Number(
          data?.pages ?? Math.max(1, Math.ceil(nTotal / Math.max(1, nLimit))),
        );
        setItems(data?.items || []);
        setTotal(nTotal);
        setLimit(nLimit);
        setPages(nPages);
        console.log('BlogPage API ->', {
          page,
          nTotal,
          nLimit,
          nPages,
          count: (data?.items || []).length,
        });
      })
      .finally(() => !cancelled && setLoading(false));

    return () => {
      cancelled = true;
    };
  }, [lang, page, limit]);

  const handlePageChange = (nextPage, nextPageSize) => {
    setPage(nextPage);
    if (nextPageSize && nextPageSize !== limit) setLimit(nextPageSize);
    topRef.current
      ? topRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
      : window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className={style.blogContainer} ref={topRef}>
      <SEOHelmet pageKey="blog" />

      <h1>{t.header.blogLink || 'Blog'}</h1>
      <Pagination
        current={page}
        total={Math.max(total, 1)}
        pageSize={limit}
        onChange={handlePageChange}
        align="center"
        className={style.pagination} // тільки для відступів/стилів
        showSizeChanger={false}
      />

      <div className={style.wrapContainer}>
        {loading && items.length === 0 ? (
          <div style={{ padding: '24px 0', opacity: 0.8 }}>Loading…</div>
        ) : items.length > 0 ? (
          items.map(el => <BlogArticleItem key={el._id} info={el} />)
        ) : (
          <div style={{ padding: '24px 0', opacity: 0.8 }}>No posts yet.</div>
        )}
      </div>

      {/* Пагінація — показуємо завжди для перевірки.
          Коли все ОК, можеш додати hideOnSinglePage або умову. */}
      <Pagination
        current={page}
        total={Math.max(total, 1)}
        pageSize={limit}
        onChange={handlePageChange}
        align="center"
        className={style.pagination} // тільки для відступів/стилів
        showSizeChanger={false}
      />
    </div>
  );
}
